var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "chat-group" } },
    [
      _vm.chatWindowStatus == 3 && _vm.threadState != "closed"
        ? _c("stream", { attrs: { id: "videocall" } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "chat-window-container" },
        [
          this.isChatOpened
            ? _c("chat-window", {
                attrs: { business_group: _vm.business_group },
              })
            : _c("chat-button", {
                attrs: { business_group: _vm.business_group },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }